<template>
  <div class="form-input-payment">
    <div class="form-input-payment__title">{{ props.paymentGroup.groupName }}</div>
    <div class="form-input-payment__list">
      <payment-card
        v-for="item in viewList"
        :key="item.id"
        :method-name="item.methodName"
        :path="item.path"
        :title="item.name"
        :is-active="isSelectedPayment(item)"
        :tag="item.tag"
        @click="selectItem(item)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { IPaymentGroup, IPaymentMethod } from '@skeleton/core/types';
  import { PayMethodToTitle } from '@skeleton/consts/method';

  interface IViewItem {
    id: string;
    methodId: string;
    endpoint?: string | number;
    name: string;
    path: string;
    methodName: string;
    tag: string | null;
  }

  interface IProps {
    activePaymentMethod?: IPaymentMethod;
    paymentGroup: IPaymentGroup;
    balanceOperation: 'deposit' | 'withdraw';
  }

  const emit = defineEmits(['update:activeProvider', 'update:activePaymentMethod']);

  const props = defineProps<IProps>();

  const {
    public: { gamehubCdn },
  } = useRuntimeConfig();

  const viewList = computed((): IViewItem[] => {
    return props.paymentGroup.paymentMethods.map(item => ({
      id: item.methodId,
      methodId: item.methodId,
      name: getTitle(item.method),
      path: getPaymentCardImg(item.method),
      methodName: item.method,
      tag: item.tag,
    }));
  });

  const isSelectedPayment = (item: IViewItem) => {
    if (props.activePaymentMethod?.methodId) {
      return item.id === props.activePaymentMethod.methodId;
    }

    return false;
  };

  const selectItem = (item: IViewItem) => {
    const foundMethod = props.paymentGroup.paymentMethods.find(method => method.methodId === item.methodId);

    if (!foundMethod) return;

    emit('update:activePaymentMethod', foundMethod);
  };

  const getTitle = (method: string): string => {
    return PayMethodToTitle[method] || formatPayMethodKey(method);
  };

  const getPaymentCardImg = (method: string) => {
    return `${gamehubCdn}/payments/${formatPayMethodKey(method)}.svg`;
  };
</script>

<style lang="scss" src="~/assets/styles/components/form/input/payment.scss" />
